var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8587",
    "data-name": "Rectangle 8587",
    width: 24,
    height: 24,
    transform: "translate(1214.5 283)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9538",
    "data-name": "Group 9538",
    transform: "translate(-1214.5 -283)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14582",
    "data-name": "Path 14582",
    d: "M1238.5,295a12,12,0,1,0-13.88,11.854v-8.385h-3.04V295h3.04v-2.644c0-3.007,1.8-4.668,4.54-4.668a18.4,18.4,0,0,1,2.68.234v2.953h-1.51a1.73,1.73,0,0,0-1.95,1.875V295h3.32l-.53,3.469h-2.79v8.385A12,12,0,0,0,1238.5,295Z",
    fill: "#858689"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.65e1b454b0bdc77eed6689a9b60c02b3.svg";
export { ForwardRef as ReactComponent };